import React from 'react'

export const TabZakupki: React.FC = () => {
    return <>TabZakupki</>
}
